import { mesaColorNames } from '@/src/common/theme'
import Svg, { Path, type SvgProps } from 'react-native-svg'

export function PurchaseIcon(props: SvgProps) {
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M5 1.66675L2.5 5.00008V16.6667C2.5 17.1088 2.67559 17.5327 2.98816 17.8453C3.30072 18.1578 3.72464 18.3334 4.16667 18.3334H15.8333C16.2754 18.3334 16.6993 18.1578 17.0118 17.8453C17.3244 17.5327 17.5 17.1088 17.5 16.6667V5.00008L15 1.66675H5Z"
        stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.5 5H17.5"
        stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.3337 8.3335C13.3337 9.21755 12.9825 10.0654 12.3573 10.6905C11.7322 11.3156 10.8844 11.6668 10.0003 11.6668C9.11627 11.6668 8.26842 11.3156 7.6433 10.6905C7.01818 10.0654 6.66699 9.21755 6.66699 8.3335"
        stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
